import { Form, Input } from "antd";
import type { FormInstance, Rule } from "antd/es/form";

const ModuleForm = ({
  mode,
  moduleForm
}: {
  mode: string;
  moduleForm: FormInstance;
}) => {
  const requiredRule: Rule = { required: true, message: "Required" };

  return (
    <div className="mb-5">
      <Form.Item name="name" label={<>Name<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Input size="large" placeholder={"Name"} maxLength={30} />
      </Form.Item>
      <Form.Item name="route" label={<>Route<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Input size="large" placeholder={"Route, ex. /path"} maxLength={100} />
      </Form.Item>
    </div>
  );
};

export default ModuleForm;
